import './Onboarding.scss'

import { useFn } from '@eturi/react'
import { hasOnboardingUserConcerns$, hasOnboardingUsers$, isAuthenticated$ } from '@op/services'
import { useSelector } from 'react-redux'
import { trialDurationInDays$ } from '../../../compound-selectors/product'
import { useNavTo } from '../../../hooks'
import {
	onboardingCurrentPage$,
	setOnboardingPage,
	setOnboardingSettled,
} from '../../../reducers/app-misc.slice'
import { useAppDispatch } from '../../../types'
import { Btn } from '../../../widgets'
import { ONBOARDING_PAGES } from '../constants'
import { OnboardingProgressBar } from './OnboardingProgressBar'

export const OnboardingHeader = () => {
	const d = useAppDispatch()
	const isAuthenticated = useSelector(isAuthenticated$)
	const navTo = useNavTo()
	const onboardingCurrentPage = useSelector(onboardingCurrentPage$)
	const trialDurationInDays = useSelector(trialDurationInDays$)
	const hasUserConcerns = useSelector(hasOnboardingUserConcerns$)
	const hasUsers = useSelector(hasOnboardingUsers$)

	const currentPageIdx = Math.max(0, ONBOARDING_PAGES.indexOf(onboardingCurrentPage))
	const showBackBtn = onboardingCurrentPage != 'concerns' && onboardingCurrentPage != 'loading'
	const showSkipBtn =
		onboardingCurrentPage == 'concerns' ? !hasUserConcerns
		: onboardingCurrentPage == 'children' ? !hasUsers
		: false

	const handleBackClick = useFn(() => {
		if (!showBackBtn) return

		// If we're on summary, we go back two pages, skipping over the loading page
		const prevPage = ONBOARDING_PAGES[currentPageIdx - (onboardingCurrentPage == 'summary' ? 2 : 1)]

		d(setOnboardingPage(prevPage))
	})

	const handleSkipClick = useFn(() => {
		if (!showSkipBtn) return

		const nextPage = ONBOARDING_PAGES[currentPageIdx + 1]

		if (!nextPage || onboardingCurrentPage == 'children') {
			d(setOnboardingSettled(true))
			return navTo(isAuthenticated ? '/manage' : '/signup')
		}

		d(setOnboardingPage(nextPage))
	})

	const progressPercent = ((currentPageIdx + 1) / ONBOARDING_PAGES.length) * 100

	return (
		<div className="w-full flex flex-col">
			<div className="onboarding-shadow w-full flex justify-center bg-teal-hl h-16 p-2">
				<div className="max-w-screen-lg justify-between items-center h-full w-full flex">
					<div className="min-w-18 sm:min-w-28 flex justify-start mt-1">
						{showBackBtn && (
							<Btn onClick={handleBackClick} invert size="sm">
								Back
							</Btn>
						)}
					</div>

					<h4 className="font-semibold text-lg text-center text-balance">
						Try Free for {trialDurationInDays} days
					</h4>

					<div className="min-w-18 sm:min-w-28 flex justify-end mt-1">
						{showSkipBtn && (
							<Btn onClick={handleSkipClick} invert size="sm">
								Skip
							</Btn>
						)}
					</div>
				</div>
			</div>
			<OnboardingProgressBar progressPercent={progressPercent} className="w-full" />
		</div>
	)
}
